import React from "react";
import WbIncandescentOutlinedIcon from "@mui/icons-material/WbIncandescentOutlined";

import * as S from "./styles";

interface IButtonSuggestionIconForInput {
	disabled?: boolean | undefined;
	onClickCustom: () => void;
	disabelCursorPointer?: boolean;
	children?: React.ReactNode | undefined;
}
function ButtonSuggestionIconForInput({
	disabled,
	onClickCustom,
	disabelCursorPointer = false,
	children,
}: IButtonSuggestionIconForInput) {
	return (
		<S.Container id="id-general-icon-forInput">
			{children}
			{!disabled && (
				<S.ButtonSuggestionIcon
					disabelPosition={!children}
					onClick={() => onClickCustom()}
					disabelCursorPointer={disabelCursorPointer || !children}
				>
					<WbIncandescentOutlinedIcon fontSize="large" style={{ rotate: "180deg" }} />
				</S.ButtonSuggestionIcon>
			)}
		</S.Container>
	);
}

export default ButtonSuggestionIconForInput;
